import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "./Header.scss";

interface Props {
    top():void,
    archive?():void,
    guide?():void,
    isAuth:boolean,
}

const Header = (props:Props)=> {
	return (
        <div style={{position:"absolute",top:"0",right:"0",zIndex:999}}>
            <span className="clickable" onClick={props.top}><FontAwesomeIcon icon="home" style={{marginRight:"0.5em"}}/></span>
            {props.archive && props.isAuth &&
            <span className="clickable" onClick={props.archive}><FontAwesomeIcon icon="list-alt" style={{marginLeft:"1em",marginRight:"0.5em"}}/></span>
            }
            {props.guide &&
            <IconButton aria-label="config" color="inherit" onClick={props.guide}>
                <ContactSupportIcon style={{color:"white"}}/>
            </IconButton>
            }
        </div>
	);
}

export default Header;
